(function(){
  function applyFixes() {
    // Fix variant button alignment
    document.querySelectorAll(".variant-option").forEach(function(opt){
      opt.style.cssText="flex:1 1 0;min-width:0;margin:0!important;height:44px!important;display:flex!important;align-items:center!important;box-sizing:border-box;";
    });
    // Fix variant selection - listen on both radio change AND label click
    function updateDisplay(radio) {
      var el=document.querySelector("[data-selected-option=Size]");
      if(el) el.textContent=radio.value;
      document.querySelectorAll(".collar-variant-btn").forEach(function(l){l.classList.remove("active")});
      var label=document.querySelector('label[for="'+radio.id+'"]');
      if(label) label.classList.add("active");
    }
    var radios=document.querySelectorAll("input[type=radio][data-option-position]");
    radios.forEach(function(radio){
      radio.addEventListener("change",function(){updateDisplay(radio);});
    });
    // Also listen on label clicks directly
    document.querySelectorAll(".collar-variant-btn").forEach(function(label){
      label.addEventListener("click",function(){
        setTimeout(function(){
          var checked=document.querySelector("input[type=radio][data-option-position]:checked");
          if(checked) updateDisplay(checked);
        },50);
      });
    });
  }
  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded", applyFixes);
  } else {
    applyFixes();
  }
})();
